import React from 'react';
import './index.less';

interface IProps {
    value?: string
    onChange: (e) => void
    addButtonClick: () => void
}

const SoilDebounceSelectComponent = (props: IProps) => {
    const {
        value,
        onChange,
        addButtonClick
    } = props;

    return (
        <div className='coordinate-base-input-container' >
            <input
                className='select-input-inner-container'
                placeholder='Longitude, Latitude'
                onChange={(e) => onChange(e)}
                value={value}
            />
            <button onClick={() => addButtonClick()} className={ `add-lat-lon-button ${value.length > 0 && 'add-lat-lon-button-value'}`}>
                Add
            </button>
        </div>
    );
};

export default SoilDebounceSelectComponent;